import React from 'react'
import './styles/treatments-template.css'
import imgWhats from '../pages/media/whats.png';


export default function WhatsAppBubble() {

    const styless = {
        backgroundImage: `url(${imgWhats})`,
        backgroundColor: 'white',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        height: '70px',
        width: '70px',
        borderRadius: '50%',
        boxShadow: 'rgb(0 0 0 / 15%) 0px 10px 30px',
        position: 'fixed',
        bottom: '30px',
        right: '30px',
        zIndex: '9999'
    }
    return (
        <div>
            <a target="_blank" style={styless} href="https://wa.me/50683535259/?text=Buenas%20me%20gustaría%20hacer%20una%20consulta."></a>
        </div>
    )
}
